import { lazy } from 'react'
import { Redirect } from 'react-router-dom'

const MiscRoutes = [
  {
    path: '/pricing',
    component: lazy(() => import('../../views/apps/pricing')),
    meta: {
      action: 'true',
      resource: 'brands_v2'
    }
  }
  // {
  //   path: '/brands/pay',
  //   component: lazy(() => import('../../views/brands/pay')),
  //   meta: {
  //       action: 'read',
  //       resource: 'brands_v2'
  //     }
  // },
]

export default MiscRoutes
